import { Button, Group, Modal, Text } from '@mantine/core';

const AlertModal = ({ show, handleOnClick, headerTitle, messageBody, buttonText }) => {
    return (
        <Modal
            opened={show}
            onClose={handleOnClick}
            centered
            title={headerTitle}
            styles={{
                title: { fontWeight: 600 },
                header: { backgroundColor: '#1E70E0', color: '#fff' },
            }}
        >
            <Text mb="md">{messageBody}</Text>
            <Group justify="flex-end">
                <Button onClick={handleOnClick}>{buttonText}</Button>
            </Group>
        </Modal>
    );
};

export default AlertModal;

